import { palette } from '@primeng/themes';

const primary = palette('#005EAA');
const secondary = palette('#f63');
const surface = {
  0:"#ffffff",
  50:"#f8fafc",
  100:"#f1f5f9",
  200:"#e2e8f0",
  300:"#cbd5e1",
  400:"#94a3b8",
  500:"#64748b",
  600:"#475569",
  700:"#334155",
  800:"#1e293b",
  900:"#0f172a",
  950:"#020617",
};

export const COLORS: IColors = {
  primary,
  secondary,
  colorScheme: {
    light: {
      surface
    },
    dark: {
      surface
    }
  }
};

interface IColors {
  primary: { [key: string]: any };
  secondary: { [key: string]: any };
  colorScheme: {
    light: {
        surface: IPalete;
    },
    dark: {
      surface: IPalete;
    }
  }
}

interface IPalete {
  0: string
  50: string
  100: string
  200: string
  300: string
  400: string
  500: string
  600: string
  700: string
  800: string
  900: string
  950: string
}